<template>
  <div v-if="isAmadeus()" class="amadeus-footer-container">
    <img src="https://assets-mp.meetingpackage.com/sites/all/themes/custom/amadeus/images/guideline-light.svg" width="25%" />
  </div>
  <div v-else class="footer">
    <div id="new_footer_section" >
        <section class="footer--upper--section layout layout--dark layout--inverse layout--mid">
            <div class="row row--2-medium">
                <div class="col_footer">
                    <a href="https://meetingpackage.com" class="footer__logo">
                        <img class="logo-image" src="/sites/all/themes/custom/meetingpackage/templatesv3/src/img/logo-mp.svg" alt="MeetingPackage.com">
                    </a>
                    <MPLanguage />
                </div>
                <div class="col_footer">
                    <h4 class="list__title">
                        Solutions </h4>
                    <ul class="list">
                        <li class="list__item">
                            <a href="https://meetingpackage.com/web/hotel-chains" class="list__link">Hotel Chains</a>
                        </li>
                        <li class="list__item">
                            <a href="https://meetingpackage.com/web/independent-hotels" class="list__link">Independent
                                Hotels</a>
                        </li>
                        <li class="list__item">
                            <a href="https://meetingpackage.com/web/partners" class="list__link">Partners</a>
                        </li>
                        <li class="list__item">
                            <a href="https://meetingpackage.com/web/unique-venues/" class="list__link">Unique
                                Venues and Event spaces</a>
                        </li>
                        <a href="https://meetingpackage.com/web/meeting-rooms-near-me/" class="list__link">
                                Explore meeting rooms</a>
                        </li>
                    </ul>
                </div>
                <div class="col_footer">
                    <h4 class="list__title">
                        Products </h4>
                    <ul class="list">
                        <li class="list__item">
                            <a href="https://meetingpackage.com/web/booking-engine-for-meetings-events/" class="list__link">Online
                                Booking Engine</a>
                        </li>
                        <li class="list__item">
                            <a href="https://meetingpackage.com/web/channel-manager/" class="list__link">
                                Channel Manager</a>
                        </li>
                        <li class="list__item">
                            <a href="https://meetingpackage.com/web/venue-sales-management/" class="list__link">Venue Sales Management</a>
                        </li>
                        <li class="list__item">
                            <a href="https://meetingpackage.com/web/integrations-api/" class="list__link">Integrations</a>
                        </li>
                        <li class="list__item">
                            <a href="https://meetingpackage.com/web/analytics-reports/" class="list__link">Analytics</a>
                        </li>
                    </ul>
                </div>
                <div class="col_footer">
                    <h4 class="list__title">
                        More </h4>
                    <ul class="list">
                        <li class="list__item">
                            <a href="https://meetingpackage.com/web/about-us/" class="list__link">Company</a>
                        </li>
                        <li class="list__item">
                            <a href="https://meetingpackage.com/web/contact-us/" class="list__link">Contact</a>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
        <section class="footer--lower--section layout layout--tight layout--inverse layout--darker">
            <div class="row">
                <div class="col_footer">
                    <ul class="inline-list">
                        <li class="inline-list__item_different">
                            <a :href="'https://meetingpackage.com' + (lang ? (lang ): '') + '/all-meeting-rooms'" class="inline-list__link">{{strings.allMeetingrooms}}</a>
                        </li>
                        <li class="inline-list__item_different">
                            <a :href="'https://meetingpackage.com' + (lang ? (lang): '') + '/all-venues'" class="inline-list__link">{{strings.allVenues}}</a>
                        </li>
                        <li class="inline-list__item_different">
                            <a href="https://meetingpackage.com/web/terms-of-service" class="inline-list__link">{{strings.termsOfService}}</a>
                        </li>
                        <li class="inline-list__item_different">
                            <a href="https://meetingpackage.com/web/privacy-policy" class="inline-list__link">{{strings.privacyPolicy}}</a>
                        </li>
                        <li class="inline-list__item_different">
                            <a href="https://meetingpackage.com/web/data-processing-and-general-terms" class="inline-list__link">{{strings.dataProcessingTerms}}</a>
                        </li>
                        <li class="inline-list__item_different">
                            <a :href="'https://meetingpackage.com' + (lang ? (lang ): '') + '/user/login'" class="inline-list__link">{{strings.login}}</a>
                        </li>
                    </ul>
                </div>
                <div class="col_footer footer__copyright_different">
                    © Cocouz oy. All rights reserved. </div>
            </div>
        </section>
    </div>
  </div>
</template>

<script>
import MPLanguage from './Language.vue';
export default {
  name: 'Footer',
  components: {
    MPLanguage
  },
  methods: {
    isAmadeus() {
      return window.location.hostname === 'vsm.amadeus-hospitality.com'
    }
  },
  computed: {
    strings () {
	    return this.$store.state.strings
    },
    lang() {
      let lang = this.$store.state.selectedLang;
      if(lang == 'en'){
        lang = '';
      } else {
        lang = '/' + lang;
      }
      return lang;
    },
    currentLang() {
        return this.$store.state.selectedLang;
    }
  }
}
</script>

<style scoped>
@charset "UTF-8";

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box
}

#new_footer_section {
    -webkit-font-smoothing: antialiased;
    font-size: 16px;
    font-weight: 400;
    color: #03315e;
}

#new_footer_section {
    font-family: "Open Sans", Helvetica, sans-serif
}

#new_footer_section img {
    max-width: 100%;
    height: auto
}

#new_footer_section h4 {
    font-size: 1.25em;
    font-weight: 700;
    color: inherit;
    margin-bottom: .25em;
    line-height: 1.25
}

@media (min-width:639px) {
    #new_footer_section h4 {
        font-size: 1.5em
    }
}

#new_footer_section a {
    color: #0055a9
}

#new_footer_section .layout {
    padding: 3em 0
}

@media (min-width:639px) {
    #new_footer_section .layout {
        padding: 4em 0
    }
}

@media (min-width:1023px) {
    #new_footer_section .layout {
        padding: 7em 0
    }
}

#new_footer_section .layout--mid {
    padding: 2em 0
}

@media (min-width:639px) {
    #new_footer_section .layout--mid {
        padding: 3em 0
    }
}

@media (min-width:1023px) {
    #new_footer_section .layout--mid {
        padding: 5em 0
    }
}

#new_footer_section .layout--tight {
    padding: 2em 0
}

#new_footer_section .layout--inverse {
    color: #fff
}

#new_footer_section .layout--dark {
    /*background-color: #003b76*/
    background-color: #fff;
}

#new_footer_section .layout--darker {
    background-color: #0050FF;
}

#new_footer_section .row {
    display: -ms-flexbox;
    display: flex;
    max-width: 1169px;
    margin: 0 auto;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap
}

@media (min-width:639px) {
    #new_footer_section .row {
        -ms-flex-wrap: nowrap;
        flex-wrap: nowrap
    }
}

@media (min-width:639px) {
    #new_footer_section .row--2-medium {
        -ms-flex-wrap: wrap;
        flex-wrap: wrap
    }

    #new_footer_section .row--2-medium .col_footer {
        -ms-flex: 0 1 50%;
        flex: 0 1 50%
    }
}

@media (min-width:1023px) {
    #new_footer_section .row--2-medium {
        -ms-flex-wrap: nowrap;
        flex-wrap: nowrap
    }
}

#new_footer_section .col_footer {
    -ms-flex: 1 1 100%;
    flex: 1 1 100%;
    padding: 0 1em
}

@media (min-width:639px) {
    #new_footer_section .col_footer {
        -ms-flex: 1 1 auto;
        flex: 1 1 auto
    }
}

#new_footer_section .footer__logo {
    display: block;
    padding: 1em 3em;
    text-align: center;
    margin-bottom: 24px;
}

@media (min-width:639px) {
    #new_footer_section .footer__logo {
        text-align: left;
        padding: 0
    }
}

#new_footer_section .footer__copyright_different {
    font-size: 12px;
    text-align: center
}

@media (min-width:639px) {
    #new_footer_section .footer__copyright_different {
        text-align: right
    }
}

#new_footer_section .inline-list {
    font-size: .75em;
    margin-bottom: 1em;
    list-style-type: none;
    text-align: center
}

@media (min-width:639px) {
    #new_footer_section .inline-list {
        text-align: left;
        display: -ms-flexbox;
        display: flex;
        margin-bottom: 0
    }
}

#new_footer_section .inline-list__item_different {
    display: block
}

@media (min-width:639px) {
    #new_footer_section .inline-list__item_different {
        margin-right: 1em
    }

    #new_footer_section .inline-list__item_different:last-child {
        margin-right: 0
    }
}

#new_footer_section .inline-list__link {
    display: block;
    padding: .5em 0;
    color: white;
    text-decoration: none
}

#new_footer_section .inline-list__link:hover {
    color: #fff
}

@media (min-width:639px) {
    #new_footer_section .inline-list__link {
        padding: 0
    }
}

#new_footer_section .list {
    list-style-type: none;
    margin-bottom: 2em;
    text-align: center
}

@media (min-width:639px) {
    #new_footer_section .list {
        text-align: left
    }
}

@media (min-width:1023px) {
    #new_footer_section .list {
        margin-bottom: 0
    }
}

#new_footer_section .list__title {
    font-size: 1em;
    margin-bottom: .5em;
    text-align: center;
    color: #16181b;
    /*color: rgba(255, 255, 255, .5)*/
}

@media (min-width:639px) {
    #new_footer_section .list__title {
        text-align: left
    }
}

@media (min-width:1023px) {
    #new_footer_section .list__title {
        margin-bottom: 1.5em
    }
}

#new_footer_section .list__item {
    display: block
}

#new_footer_section .list__link {
    display: block;
    /*color: #fff;*/
    color: #16181b;
    text-decoration: none;
    font-size: 1em;
    padding-bottom: .5em;
    transition: all .35s cubic-bezier(.2, .7, .3, 1)
}

#new_footer_section .list__link:hover {
    opacity: 1;
    transition: none;
    text-decoration: underline;
}

#new_footer_section #lang_dropdown_wrapper {
    margin-top: 15px;
}

.sidebar-active #new_footer_section {
    width: calc(100% - 229px);
    margin-left: 229px;
}

#new_footer_section h4 {
  border-bottom: none;
  text-transform: none;
}

.amadeus-footer-container {
  min-height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #005EB8;
  padding: 0px;
}

</style>


